import React from 'react';
import classnames from 'classnames';

import styles from './ViewerIcon.module.scss';

export type ViewerIconProps = {
  cssClass?: string;
  onClick?: () => void;
};

const ViewerIcon: React.FC<ViewerIconProps> = (props) => {
  return (
    <div className={classnames(styles.ff_viewer_icon, props.cssClass)} data-testid='viewer-icon' onClick={() => props.onClick && props.onClick()}>
      {props.children}
    </div>
  );
};

export default ViewerIcon;
